import { ChangeEvent, FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@robocorp/components';
import { IconCloseSmall } from '@robocorp/icons';
import { IconSearch } from '@robocorp/icons/iconic';

interface Props {
  search: string;
  onSearchChange: (search: string) => void;
}

export const FilterSearch: FC<Props> = ({ search, onSearchChange }) => {
  const { t } = useTranslation();

  const onSearchValueChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onSearchChange(event.target.value),
    [onSearchChange],
  );

  const onClearSearch = useCallback(() => {
    onSearchChange('');
  }, [onSearchChange]);

  return (
    <Input
      placeholder={t('search')}
      iconLeft={IconSearch}
      value={search}
      onChange={onSearchValueChange}
      aria-label={t('search') as string}
      iconRight={search ? IconCloseSmall : undefined}
      onIconRightClick={onClearSearch}
      iconRightLabel={t('searchClear')}
    />
  );
};
